import { CampaignObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type DeleteCampaignResponse = {
    result: string;
}

type UseDeleteCampaignOverviewResponse = [
    (data: CampaignObject) => Promise<DeleteCampaignResponse | null>,
    {
        value?: DeleteCampaignResponse;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const useDeleteCampaignOverview = (): UseDeleteCampaignOverviewResponse => {
    
    const [post, postState] = usePost<DeleteCampaignResponse, CampaignObject>({
        url: "settings/set-delete"
    })

    const deleteCampaign = async (
        data : CampaignObject
    ) : Promise<DeleteCampaignResponse | null> => {

        const result = await post(data);
        return result;
    }

    return [deleteCampaign, postState];
};